import React from 'react';
import { observer } from 'mobx-react';
import { Callout, CalloutContent } from '@sheinc/shelikes-design-system';
import { Page, PageHeader } from '../../components/layout/page';
import { usePaymentList } from './states/PaymentListState';
import { PaneSubHeader } from '../../../mainv3/components/molecules/mypage/page';
import { LoaderRow } from '../../../mainv3/components/atoms/layout/LoaderRow';
import { LegacyPaymentView } from '../../../mainv3/components/organisms/mypage/LegacyPaymentView';
import { V3Routes } from '../../../mainv3/routes';

export const PaymentListPage = observer(() => {
  const state = usePaymentList();
  const { paymentsResource, loading } = state;
  const payments = paymentsResource.getOrElse([]);

  return (
    <Page id="payment-list-page">
      <PageHeader>お支払い情報 / 変更</PageHeader>

      <Callout variant="info" icon>
        <CalloutContent
          description={
            <>
              お支払い情報の変更は、SHElikesのマイアカウントページからのみ受け付けています。
              <a href={V3Routes.likesUrl('/myaccount/payments?from=money')}>こちら</a>
              より該当のページへアクセスし、新しい情報をご登録ください。
            </>
          }
        />
      </Callout>

      <PaneSubHeader title="お支払い履歴 / 予定" />

      {loading && <LoaderRow />}

      {payments.map((payment, i) =>
        payment.order_base_price > 0 ? (
          <LegacyPaymentView
            key={i}
            payment={payment}
            showAction={true}
            isHideBilling={true}
            retry_payment_route="account"
          />
        ) : null
      )}
    </Page>
  );
});
